import { Component, HostListener, Inject, Injector, Input, OnInit, ViewChild } from '@angular/core';
import {
  entityState,
  jkLib,
  jkRestReturn,
  JkTableService,
  PageKind,
} from 'jk-service';
import { MaterialModule } from 'jk-service';
import { DatePipe, CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContentChange, QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { quillEditorOptions } from 'jk-service';
import { MtrwlService } from '../services/mtrwl.service';
import { jkSingleComponent, JkSingleTableComponent, } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-mtrki04-detail',
  templateUrl: './mtrki04-detail.component.html',
  styleUrls: ['./mtrki04-detail.component.scss'],
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule,//DatePipe,
    QuillModule, CommonModule, FormsModule
  ],
})
export class Mtrki04DetailComponent extends JkSingleTableComponent implements OnInit {
  override _programId = 'mtrki04-detail'; //###
  isModal: boolean = true;
  override doUIRefresh(oldState: entityState, item: any): void {
    super.doUIRefresh(oldState, item);
  }
  @HostListener('document:keydown', ['$event'])
  async handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      let bool = await this.showConfirm('', '確定要離開?');
      if (bool) {
        await this.doOk(event);
      }
    }
  }
  constructor(
    public dialogRef: MatDialogRef<Mtrki04DetailComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: jkRestReturn,
  ) {
    super();
    this.srv = new MtrwlService();
    this.tableSrv = new JkTableService(); // ###
    this.pageKind = PageKind.detail;

    //this.masterSrv = data.obj.masterSrv;
    //this.srv.item = data.obj.item;
    let ownerSrv = data.obj.masterSrv;
    this.srv.linkKeyObj = { WL001: ownerSrv.item.WD001 };
    this.srv.sqlWhereDefault = ` WHERE 1=1 AND WL001='${ownerSrv.item.WD001}' `;
    this.gridInitOpt = { pageKind: this.pageKind, programId: this.programId, sortField: 'WL005', sort: 'desc', defaultSort: null };

    //this.detailBillSrv = new JkbillDetailService(); // ###
    this.tableDisplayedColumns = ['WL001'];

    //this.constructorInit();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();

    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###

  }
  override async getLookup() {
    super.getLookup();
    this.srv.sqlOrder = ` ORDER BY WL005 DESC  `;
    await this.srv.loadData();
    this.doRefresh();
  }

  override async doEditAndSave($event: any): Promise<boolean> {
    if (this.wd003Text === '') {
      this.wd003Text = $event.WL004;
    }
    this.wd003Text = await this.showInput('內容', '確認要存檔?', this.wd003Text, 'textarea');
    let bool = false;
    if (this.wd003Text) {
      $event.WL004 = this.wd003Text;
      bool = await super.doEditAndSave($event);
    };
    return bool;
  }
  async doOk(e: any) {
    this.dialogRef.close(true);
  }
  doCancel(e: any) {
    this.dialogRef.close(false);
  }

  wd003Text: string = '';
  quillEditorReady($event: ContentChange) {
    //this.myState = entityState.dsEdit;
    this.wd003Text = $event.text;
  }
  quillEditorOptions = quillEditorOptions;

  text2html(value: string): string {
    let str = jkLib.swapStr(value, '\n', '<br>');
    let s = `<h4>${str}</h4>`;
    //let s = `${str}`;
    return s;
  }
  async doInsertModi() {
    let wl004 = await this.showInput('請輸入工作內容', 'label', '', 'textarea');
    if (wl004) {
      let item = await this.srv.doInsert();
      item.WL001 = this.srv.linkKeyObj.WL001;
      item.WL004 = wl004;
      this.doUIPost(item);
      //this.doRefresh();
    }
  }

  override async doUIDelete(params?: any): Promise<boolean> {
    this.srv.item = params;
    let bool = await super.doUIDelete(params); // bool 為何 undefined?
    //this.doRefresh();
    return bool;
  }

}
